<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                
                <div class="row mb-32 gy-0 dash-top" style="padding-bottom: 500px; ">

                    <!-- POSTS -->
                    <div class="col-12" style="z-index: 9;">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">

                                <div class="mt-18 mb-24">

                                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" style="background-color: transparent;" placeholder="Search KYC...">

                                </div>

                                <!-- DUPLI -->
                                 <div class="card hp-project-ecommerce-table-card" v-for="hist in historyList" :key="hist.id"
                                            style="margin-bottom: 10px; border-radius: 10px; padding-top: 20px;">
                                            <div class="card-body " >

                                                <div class="row" >

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-3 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div
                                                                        style="display: flex; justify-content: flex-start; align-items: flex-start; cursor: pointer;">

                                                                        <div class="col hp-flex-none w-auto" @click="selfieClick(hist.selfieUrl)">

                                                                            <img :src="hist.selfieUrl"
                                                                                style="width: 58px; height: 58px; border-radius: 50%;   object-fit: cover; margin-right: 5px; border-color: #000; border-width: 1px; border-style: solid; margin-top: -10px;">

                                                                        </div>


                                                                        <div class="col hp-flex-none w-auto">
                                                                            <!-- <h6 class="mb-4 " style="width: 60%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ tran.fullname }}</h6> -->
                                                                            <h6 class="mb-4 ">{{ hist.fullLegalName }}</h6>
                                                                            <p
                                                                                class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                                {{ hist.email }}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ hist.documentType }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Document
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4">{{ hist.dob }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date of birth
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle1 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            1 month price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle2 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            3 months price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2 ">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> ₦ {{ hist.bundle3 }}</strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            6 month price
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            

                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <strong class="mb-4 mm-none">{{ hist.dateFull }}</strong>
                                                                        <strong class="mb-4 dd-none">{{ hist.dateD }}</strong>
                                                                        

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Upload date
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">
                                                                    
                                                                        <strong style="font-size: 14px;" v-if="hist.status == 'pending'"
                                                                            class="badge bg-warning-4 hp-bg-dark-warning text-warning border-none w-auto py-12 px-24 fw-medium ">
                                                                            Pending </strong>

                                                                            <strong style="font-size: 14px;" v-if="hist.status == 'cancelled'"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Declined </strong>

                                                                            <strong style="font-size: 14px;" v-if="hist.status == 'successful'"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Approved</strong>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <!-- <div class="col-6 col-sm-2" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="col hp-flex-none w-auto">
                                                                        <button class="btn btn-icon-only rounded-circle btn-primary" data-bs-toggle="modal" data-bs-target="#info" style="cursor: pointer;">
                                                                            <i class="ri-search-line remix-icon"></i>
                                                                        </button>
                                                                        
                                                                    </div>

                                                                </div>
                                                            </div> -->

                                                            <div class="col-12 col-sm-12" >
                                                                <div class="row gx-8 gy-16" >
                                                                    
                                                                    <div class="dd-none">

                                                                        <div class="col hp-flex-none" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                                                        
                                                                            <img :src="hist.frontImageUrl" alt="" style="width: 100%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px; ">

                                                                            <img v-if="hist.backImageUrl !=''" :src="hist.backImageUrl" alt="" style="width: 100%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px;">
                                                                            
                                                                        </div>

                                                                    </div>

                                                                    <div class="mm-none">

                                                                        <div class="col hp-flex-none" style="display: flex; justify-content: center; align-items: center;">
                                                                        
                                                                            <img :src="hist.frontImageUrl" alt="" style="width: 50%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px; margin-right: 10px;">

                                                                            <img v-if="hist.backImageUrl !=''" :src="hist.backImageUrl" alt="" style="width: 50%; margin-top: 10px; margin-bottom: 10px; object-fit: cover; height: 400px; border-radius: 10px;">
                                                                            
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <div class="col-12 mt-32" v-if="hist.status == 'pending'">
                                                        <div class="row g-32">

                                                            <div class="d-flex justify-content-center align-items-center" style=" margin-bottom: 50px;">
                                                                <button class="btn btn-primary" style="margin-right: 20px;" @click="approve(hist)">Approve</button>
                                                                <button class="btn btn-danger" @click="decline(hist)">Decline</button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>



                                        </div>

                                <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyUsers2">

                                    <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                
                                    </InfiniteLoading>

                                </div>

                                <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; display: none;"
                                            id="emptyUsers" >
                                    <p class="hp-badge-text">No applications...</p>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- APPROVE -->
        <div class="modal fade" id="approveModal" tabindex="-1" aria-labelledby="approveLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Are you sure?</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <p class="hp-p1-body"> Please ensure that you have reviewed the applicatoion carefully. Don't fprget to check the date of birth and ensure that the user is of legal age. </p>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        @click="approve2">Confirm</button>
                </div>
            </div>
        </div>
        </div>

        <!-- DECLINE -->
        <div class="modal fade" id="declineModal" tabindex="-1" aria-labelledby="declineModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title">Decline Application ?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <p class="hp-p1-body">Are you sure you want to decline this appliacation</p>

                    <form @submit.prevent="decline2">

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Reason</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Reason for declining the application..." style="line-height: 20px; padding-top: 10px;"
                                v-model="reason" maxlength="500" required></textarea>
                        </div>

                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal" aria-label="Close">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>







                </div>


            </div>
        </div>
        </div>

        <!-- SELFIE -->
        <div class="modal fade" id="imgModal" tabindex="-1" aria-labelledby="imgLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Selfie image</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -30px;">

                    <div class="d-flex justify-content-center align-items-center">
                        <img :src="selfieUrl" alt="" style="width: 200px; height: 200px; border-radius: 10px; background-color: #000;">
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                    
                </div>
            </div>
        </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
    
    import { db } from '@/firebase';
    import axios from 'axios';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText: "",
                errorText: "",
                successText: "",

                lastDocSnapshot: null,
                
                historyList: [],
                userCount: "",
                reason: "",
                historyObj: "",

                selfieUrl: "",
                
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display = 'none';
            document.getElementById("mobileTitle").textContent = 'Kyc';

            document.getElementById("kycN").classList.add("active");

            document.getElementById("kycN2").classList.add("active");

        },

        methods:{
            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            selfieClick(url){
                this.selfieUrl = url;
                $('#imgModal').modal('show');

            },

            async getKyc(){

                let res = [];
                const q = query(collection(db, "UserKyc"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            email: doc.data().email,
                            fullLegalName: doc.data().fullLegalName,
                            selfieUrl: doc.data().selfieUrl,
                            status: doc.data().status,
                            timeStamp: doc.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: a2.slice(0, -45),
                            userName: doc.data().username,
                            userId: doc.data().userId,
                            frontImageUrl: doc.data().frontImageUrl,
                            backImageUrl: doc.data().backImageUrl,
                            documentType: doc.data().documentType,
                            dob: doc.data().dob,
                            bundle1: doc.data().bundle1,
                            bundle2: doc.data().bundle2,
                            bundle3: doc.data().bundle3,
                            
                        }

                        
                        this.historyList.push(result);

                    })

                }

                return res.length;

            },

            async handleInfinite($state){

                const newPostCount = await this.getKyc();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.historyList.length == 0){
                        document.getElementById("emptyUsers").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyUsers2").style.display = "none";
                    return $state.complete();

            },

            approve(obj){
                this.historyObj = obj;
                $('#approveModal').modal('show');
            },

            async approve2(){

                //loading
                this.loadingText = "Approving application...";
                this.$refs.loadingModal.classList.add("bg-active");

                //send mail to user
                axios.post('https://api.baesnap.com/v1/kyc-success-mail', {
                    toName: this.historyObj.fullLegalName,
                    toEmail: this.historyObj.email,
                })
                .then(function (response) {
                    //console.log(response);
                })
                
                //update trans
                const kycRef = doc(db, "UserKyc", this.historyObj.id);
                await updateDoc(kycRef, {
                    status: "successful"
                });

                const priceRef = doc(db, "Users", this.historyObj.userId);
                await updateDoc(priceRef, {
                    bundle1: this.historyObj.bundle1,
                    bundle2: this.historyObj.bundle2,
                    bundle3: this.historyObj.bundle3,
                    type: "model",
                    profileType: "sub"
                });

                const adminRef = doc(db, "AdminInfo", "info");
                await updateDoc(adminRef, {
                    usersCount: increment(-1),
                    modelCount: increment(1)
                });

                $('#approveModal').modal('hide');
                this.successText = "The application was approved successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            decline(obj){

                this.historyObj = obj;
                $('#declineModal').modal('show');

            },

            async decline2(){

                //loading
                this.loadingText = "Declining application...";
                this.$refs.loadingModal.classList.add("bg-active");

                //send mail to user
                axios.post('https://api.baesnap.com/v1/kyc-failed-mail', {
                    toName: this.historyObj.fullLegalName,
                    toEmail: this.historyObj.email,
                    reason: this.reason
                })
                .then(function (response) {
                    //console.log(response);
                })
                
                //update trans
                const kycRef = doc(db, "UserKyc", this.historyObj.id);
                await updateDoc(kycRef, {
                    status: "cancelled"
                });

                $('#declineModal').modal('hide');
                this.successText = "The application was declined successfully. The user will be notified";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },
        }
        
    }

</script>